import apiSecurityCover from '../assets/whitepapers/whitepaper-cover.png';
const whitepapers = [
  {
    id: 'api-security-threat-landscape',
    slug: 'api-threat-landscape',
    title: 'A Strategic Analysis of the Modern API Threat Landscape and Defensive Posture',
    summary:
      'A strategic analysis of API security that blends threat intelligence, attacker playbooks, operator tooling, and layered safeguards for resilient defenses.',
    category: 'API Security',
    readingTime: '26 min read',
    dateLabel: '2025 Edition',
    coverImage: apiSecurityCover,
    pdfUrl: '/whitepapers/api-threat-landscape.pdf',
    author: 'Rajesh Mondal',
  },
];

export default whitepapers;
